import { Component, HostListener } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MobileWidthCheckerService } from '@services/mobile-width-checker.service';
import { AuthService } from '@services/auth.service';
import { NotificationToastService } from '@services/notification-toast.service';
import { ToastMessageOptions } from 'primeng/api';

@Component({
  selector: 'app-layout',
  standalone: false,

  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})
export class LayoutComponent {
  currentLang: string = 'ar';
  isAuthenticated!: boolean;
  isMobileScreen$ = this.mobileWidthCheckerService.isMobileScreen$;
  isSidebarOpen: boolean = false;

  constructor(
    private authService: AuthService,
    private translate: TranslateService,
    private mobileWidthCheckerService: MobileWidthCheckerService,
    private notificationToastService: NotificationToastService
  ) { }
  ngOnInit() {
    this.isAuthenticated = this.authService.isAuthenticated();
    this.currentLang = this.translate.getDefaultLang() || 'ar';
    this.translate.onLangChange.subscribe((event) => {
      this.currentLang = event.lang;
    });

    // Initialize notification toast service
    if (this.isAuthenticated) {
      this.notificationToastService.initialize();
    }
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const sidebarElement = document.querySelector('.sidebar');
    const toggleButton = document.querySelector('.sidebar-toggle');

    if (
      this.isSidebarOpen &&
      sidebarElement &&
      toggleButton &&
      !sidebarElement.contains(event.target as Node) &&
      !toggleButton.contains(event.target as Node)
    ) {
      this.closeSidebar();
    }
  }

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  closeSidebar() {
    this.isSidebarOpen = false;
  }

  onToastClick(message: ToastMessageOptions): void {
    const purchaseOrderId = message.data?.['purchaseOrderId'];
    if (purchaseOrderId) {
      this.notificationToastService.navigateToOrder(purchaseOrderId);
    }
  }
}
